import { render, staticRenderFns } from "./ManageServicePacks.vue?vue&type=template&id=0d5019b8"
import script from "./ManageServicePacks.vue?vue&type=script&lang=js"
export * from "./ManageServicePacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports